import { useEffect } from 'react';
import { useValuationsStore } from '../store/valuationsStore';
import { useQueryVariables } from './useQueryVariables';
import { useWatchList } from './useWatchList';

const useGetWatchList = () => {
  const variables = useQueryVariables();
  const { watchList, loading } = useWatchList(variables);
  const watchListView = useValuationsStore.use.watchListView();
  const setSortedAssets = useValuationsStore.use.setSortedAssets();
  const setWatchlistAssetIds = useValuationsStore.use.setWatchlistAssetIds();
  const setTotalCount = useValuationsStore.use.setTotalCount();
  const setLoadingAssets = useValuationsStore.use.setLoadingAssets();

  useEffect(() => {
    if (watchListView) {
      setSortedAssets(watchList);
      setTotalCount(watchList.length);
    }
  }, [watchList, watchListView, setSortedAssets, setTotalCount]);

  useEffect(() => {
    if (watchListView) {
      setLoadingAssets(loading);
    }
  }, [loading, watchListView, setLoadingAssets]);

  useEffect(() => {
    const ids = new Set(watchList.map(asset => asset.id));
    setWatchlistAssetIds(ids);
  }, [watchList, setWatchlistAssetIds]);
};

export { useGetWatchList };
